import React, { useState } from "react";

const SendGuideForm = () => {
  // State to manage form data and submission status
  const [formData, setFormData] = useState({
    email: "",
    isLeadMagnet: "YES",
  });
  const [status, setStatus] = useState("");

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      console.log("Sending form data:", JSON.stringify(formData));
      const response = await fetch(
        "https://hook.us2.make.com/xpd5n8trco0cn3vtfvojoddhviy56bc7",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      // Check response status
      if (response.ok) {
        setStatus("✅ Thank you! We'll be in touch soon.");
        // Reset form data
        setFormData({
          email: "",
          isLeadMagnet: "YES",
        });
      } else {
        setStatus("❌ An error occurred. Please try again later.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setStatus(
        "❌ An error occurred while submitting. Please try again later."
      );
    }
  };

  return (
    <div className="flex items-center justify-center md:min-h-screen bg-gradient-to-br from-blue-600 via-teal-500 to-blue-800 p-6">
      <div className="bg-white rounded-xl shadow-lg p-8 max-w-lg w-full animate-fade-in">
        <h2 className="text-teal-600 text-sm font-semibold mb-2 text-center">
          == Free Guide ==
        </h2>
        <h1 className="text-3xl font-bold text-center text-blue-900 mb-4">
          4 Simple Steps to Grow Your Business Quickly with AI Automation
        </h1>
        <p className="text-gray-700 text-center mb-6">
          AI automation is one of the most powerful and affordable ways to
          improve your business operations, save operational costs, scale, and
          grow quickly.
        </p>
        <p className="text-gray-700 text-center mb-6">
          In this free guide, you can read how to do that quickly. No jargon, no
          technical nonsense, just step-by-step explanations.
        </p>

        {/* Form */}
        <form onSubmit={handleSubmit} className="flex flex-col items-center">
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter your email"
            className="w-full p-3 mb-4 text-gray-900 rounded-lg border-2 border-teal-300 focus:outline-none focus:border-teal-500"
            required
          />
          <button
            type="submit"
            className="w-full bg-gradient-to-r from-teal-500 to-blue-600 text-white py-3 rounded-lg shadow-lg transform transition-transform hover:scale-105 hover:shadow-xl"
          >
            Send Me the Guide →
          </button>
        </form>

        {/* Submission Status */}
        {status && (
          <div className="mt-4 text-center">
            <p className="text-sm text-gray-700">{status}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SendGuideForm;
